import { render, staticRenderFns } from "./tv.vue?vue&type=template&id=4ed247c5&scoped=true"
import script from "./tv.vue?vue&type=script&lang=js"
export * from "./tv.vue?vue&type=script&lang=js"
import style0 from "./tv.vue?vue&type=style&index=0&id=4ed247c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed247c5",
  null
  
)

export default component.exports